import React from 'react';
import { AudiogramProps } from '../schema';
import { Oscilloscope } from '../visualizer/Oscilloscope';
import { Spectrum } from '../visualizer/Spectrum';

export const Visualizer: React.FC<AudiogramProps> = (props) => {
  const { visualizer, visualizerColor, audioFileUrl } = props;
  const baseNumberOfSamples = Number(visualizer.numberOfSamples);

  return (
    <div>
      {visualizer.type === 'oscilloscope' ? (
        <Oscilloscope
          key={audioFileUrl}
          waveColor={visualizerColor}
          padding={visualizer.padding}
          audioSrc={audioFileUrl}
          numberOfSamples={baseNumberOfSamples}
          windowInSeconds={visualizer.windowInSeconds}
          posterization={visualizer.posterization}
          amplitude={visualizer.amplitude}
        />
      ) : visualizer.type === 'spectrum' ? (
        <Spectrum
          key={audioFileUrl}
          barColor={visualizerColor}
          audioSrc={audioFileUrl}
          mirrorWave={visualizer.mirrorWave}
          numberOfSamples={baseNumberOfSamples * 4} // since fft is used, we need to increase the number of samples to get a better resolution
          freqRangeStartIndex={visualizer.freqRangeStartIndex}
          waveLinesToDisplay={visualizer.linesToDisplay}
        />
      ) : null}
    </div>
  );
};
